import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "roles" }
const _hoisted_2 = { class: "flex items-center justify-between mt-6" }
const _hoisted_3 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roles_actions = _resolveComponent("roles-actions")!
  const _component_role_permissions_list = _resolveComponent("role-permissions-list")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_roles_filters = _resolveComponent("roles-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_roles_list_item = _resolveComponent("roles-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_roles_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createRole,
          onUpdate: _ctx.updateRole,
          onDelete: _ctx.deleteRole
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.permissions_list_state.is_opened)
        ? (_openBlock(), _createBlock(_component_role_permissions_list, {
            key: 0,
            role: _ctx.permissions_list_state.role,
            onClose: _ctx.closePermissionsList
          }, null, 8, ["role", "onClose"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Роли" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить роль ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_roles_filters, {
        loading: _ctx.state.roles.is_loading,
        onSearch: _ctx.onSearch,
        onReset: _ctx.onReset,
        class: "mb-5"
      }, null, 8, ["loading", "onSearch", "onReset"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.roles.is_failed && !_ctx.state.roles.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.roles.is_loading,
              text: "При получении списка ролей произошла ошибка",
              "error-message": _ctx.state.roles.failure.error_state.message,
              "error-url": _ctx.state.roles.failure.error_state.url,
              "error-status": _ctx.state.roles.failure.error_state.status,
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadRoles(_ctx.state.roles.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.state.roles.is_loading,
              items: _ctx.state.roles.list,
              pagination: "",
              "pagination-current-page": _ctx.state.roles.pagination.current_page,
              "pagination-total-pages": _ctx.state.roles.pagination.total_pages,
              onChangePage: _ctx.loadRoles
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_roles_list_item, {
                  item: item,
                  onOpenPermissions: _ctx.openPermissionsList,
                  onUpdate: _ctx.startUpdate,
                  onDelete: _ctx.startDelete
                }, null, 8, ["item", "onOpenPermissions", "onUpdate", "onDelete"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}